import { StudentList } from './StudentList';
import { StudentCreate } from './StudentCreate';
import { StudentEdit } from './StudentEdit';
import { StudentShow } from './StudentShow';

export default {
    list: StudentList,
    create: StudentCreate,
    edit: StudentEdit,
    show: StudentShow,
};
